import { render, staticRenderFns } from "./uploadDocument.vue?vue&type=template&id=b519020a&scoped=true&"
import script from "./uploadDocument.vue?vue&type=script&lang=js&"
export * from "./uploadDocument.vue?vue&type=script&lang=js&"
import style0 from "./uploadDocument.vue?vue&type=style&index=0&id=b519020a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b519020a",
  null
  
)

export default component.exports